import { create } from 'zustand';

type Store = {
  isVisible: boolean;
  setIsVisible: (flag: boolean) => void;
};
const useStickyCartBarStore = create<Store>((set) => ({
  isVisible: false,
  setIsVisible: (flag: boolean) => set(() => ({ isVisible: flag })),
}));

export default useStickyCartBarStore;
